import * as Yup from "yup";
import { editAdminService } from "../../services/usersServices";
import Alert from "../../utils/Alert";

export const initialValues = {
    name: "",
    family: "",
    phone_number: "",
    email: "",
    address: "",
    address_code: "",
};

export const onSubmit = async (values, actions, userId) => {
    try {
        const response = await editAdminService(userId, values);
        if(response.status === 200) {
            Alert("انجام عملیات", "اطلاعات شما با موفقیت ویرایش شد.", "success")
        }
    } catch (error) {
        if(error.response && error.response.status === 400) {
            Alert(`خطا ${error.response.status}!`, "ایمیل یا شماره تلفن وارد شده در حال حاضر وجود دارد.", "error");
        }
    }
};

export const validationSchema = Yup.object({
    name: Yup.string().required("لطفاً نام را وارد کنید")
        .matches(/^[a-zA-Z\u0600-\u06FF\u200c\s]+$/, "فقط از حروف الفبای فارسی یا انگلیسی استفاده شود"),
    family: Yup.string().required("لطفاً نام خانوادگی را وارد کنید")
        .matches(/^[a-zA-Z\u0600-\u06FF\u200c\s]+$/, "فقط از حروف الفبای فارسی یا انگلیسی استفاده شود"),
    phone_number: Yup.string().required("لطفاً شماره تلفن را وارد کنید")
        .matches(/^[0-9]{11}$/, "لطفاً یک شماره تلفن معتبر وارد کنید"),
    email: Yup.string().required("لطفاً ایمیل را وارد کنید")
        .matches(/^[a-zA-Z0-9._-]+@[a-zA-Z.]+\.[a-zA-Z]{2,}$/, "لطفاً یک ایمیل معتبر وارد کنید"),
    address: Yup.string(),
    address_code: Yup.string().matches(/^[0-9]{10}$/, "کد پستی باید 10 رقمی باشد"),
});
